export default (id, prompt) => ({
  type: 'SECTIONS/PROMPT',
  payload: { id, prompt }
});
